/**
 * Reglas de validación para formularios
 * Utilizado con React Hook Form
 */

import type { } from 'react-hook-form';

export const validationRules = {
  curp: {
    required: 'CURP es requerido',
    minLength: { value: 18, message: 'CURP debe tener 18 caracteres' },
    maxLength: { value: 18, message: 'CURP debe tener 18 caracteres' },
    pattern: {
      value: /^[A-Z]{4}\d{6}[HM][A-Z]{5}[0-9A-Z]\d$/,
      message: 'Formato inválido. Ejemplo: HEGG560427MVZRRL04'
    }
  },

  rfc: {
    required: 'RFC es requerido',
    minLength: { value: 13, message: 'RFC debe tener 13 caracteres' },
    maxLength: { value: 13, message: 'RFC debe tener 13 caracteres' },
    pattern: {
      value: /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/,
      message: 'Formato inválido. Ejemplo: HEGG560427XXX'
    }
  },

  nss: {
    required: 'NSS es requerido',
    minLength: { value: 11, message: 'NSS debe tener 11 dígitos' },
    maxLength: { value: 11, message: 'NSS debe tener 11 dígitos' },
    pattern: {
      value: /^\d{11}$/,
      message: 'NSS debe contener solo números'
    }
  },

  telefonoPersonal: {
    pattern: {
      value: /^\d{10}$/,
      message: 'Teléfono debe tener 10 dígitos'
    }
  },

  emergenciaContactoTelefono: {
    pattern: {
      value: /^\d{10}$/,
      message: 'Teléfono debe tener 10 dígitos'
    }
  },

  fechaNacimiento: {
    required: 'Fecha de nacimiento es requerida'
  },

  estadoCivil: {
    required: 'Estado civil es requerido'
  },

  areaId: {
    required: 'Área es requerida',
    validate: (value: number) => value > 0 || 'Seleccione un área válida'
  },

  puestoId: {
    required: 'Puesto es requerido',
    validate: (value: number) => value > 0 || 'Seleccione un puesto válido'
  },

  fechaIngreso: {
    required: 'Fecha de ingreso es requerida'
  },

  tipoContrato: {
    required: 'Tipo de contrato es requerido'
  },

  jornada: {
    required: 'Jornada es requerida'
  },

  sueldoBrutoMensual: {
    required: 'Sueldo es requerido',
    min: { value: 0.01, message: 'Sueldo debe ser mayor a 0' }
  }
} as const;

/**
 * Formateadores de campos
 */
export const formatters = {
  curp: (value: string) => value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 18),
  rfc: (value: string) => value.toUpperCase().replace(/[^A-ZÑ&0-9]/g, '').slice(0, 13),
  nss: (value: string) => value.replace(/\D/g, '').slice(0, 11),
  phone: (value: string) => value.replace(/\D/g, '').slice(0, 10)
};
